import { render, staticRenderFns } from "./DashboardStatsCopy.vue?vue&type=template&id=306d7b6c"
import script from "./DashboardStatsCopy.vue?vue&type=script&lang=js"
export * from "./DashboardStatsCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports